import leadService from "../../services/leadService";

const getDefaultState = () => {
  return {
    valid: false,
    type: "both"
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setValid(state, value) {
      state.valid = value;
    },
    setType(state, value) {
      state.type = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    urlDecode(commit, { energy: energy }) {
      commit.setType(energy);
    },
    async save(context) {
      let data = {
        uuid: context.rootState.common.uuid,
        energy: context.state.type,
      };

      try {
        await leadService.save(data);
      } catch (error) {
        throw error;
      }

      // console.log(data.uuid);
    }
  },
  getters: {
    urlMapper: state => {
      return {
        energy: state.energy
      };
    },
    type: state => {
      return state.type
    },
    hasGas: state => {
      return state.type === "both" || state.type === "gas";
    },
    hasElec: state => {
      return state.type === "both" || state.type === "elec";
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/energy.js